const changePwd = {
  path: 'changePwd',
  component: resolve => require(['../../../../pages/modules/changePwd'], resolve),
  meta: {
    requireAuth: true
  }
}

export default changePwd
